export default __webpack_public_path__ + "static/media/inactive.45ccee8c.svg";